<h3>Seção de Banner</h3>
<form class="form-b4a" [formGroup]="form" (ngSubmit)="onSubmit()">
  <!-- <span class="p-input-checkbox">
    <p-checkbox formControlName="fixed" [binary]="true" inputId="fixed" />
    <label for="fixed">Componente fixo</label>
  </span>

  <span class="p-input-checkbox">
    <p-checkbox formControlName="editable" [binary]="true" inputId="editable" />
    <label for="editable">Editável</label>
  </span> -->

  <div class="banner-section">
    <div class="banner-item p-card">
      <div class="banner-content">
        <span class="image-upload">
          <div class="file-upload">
            <span class="p-float-label">
              <input
                type="text"
                readonly
                pInputText
                formControlName="mobileImage"
                id="mobileImage"
              />
              <label for="mobileImage">
                Imagem Mobile* - (Máx. 250kb / WEBP) Especifiações:
                {{ mobileImageWidth }}x{{ mobileImageHeight }}
              </label>
            </span>
            <p-fileUpload
              mode="basic"
              chooseLabel="Selecionar"
              name="file"
              [auto]="true"
              accept=".webp"
              [maxFileSize]="250 * 1024"
              uploadIcon="pi pi-file"
              [customUpload]="true"
              (uploadHandler)="
                onUpload(
                  $event,
                  'mobileImage',
                  desktopUpload,
                  undefined,
                  true,
                  mobileImageWidth,
                  mobileImageHeight
                )
              "
              id="mobileImage"
              #desktopUpload
            />
          </div>
          <img
            class="mobile-image-preview"
            *ngIf="form.value.mobileImage"
            [src]="form.value.mobileImage"
          />
        </span>

        <span class="image-upload">
          <div class="file-upload">
            <span class="p-float-label">
              <input
                type="text"
                readonly
                pInputText
                formControlName="desktopImage"
                id="desktopImage"
              />
              <label for="desktopImage">
                Imagem Desktop * - (Máx. 250kb / WEBP) Especifiações:
                {{ desktopImageWidth }}x{{ desktopImageHeight }}
              </label>
            </span>
            <p-fileUpload
              mode="basic"
              chooseLabel="Selecionar"
              name="file"
              [auto]="true"
              accept=".webp"
              [maxFileSize]="250 * 1024"
              uploadIcon="pi pi-file"
              [customUpload]="true"
              (uploadHandler)="
                onUpload(
                  $event,
                  'desktopImage',
                  desktopUpload,
                  undefined,
                  true,
                  desktopImageWidth,
                  desktopImageHeight
                )
              "
              id="desktopImage"
              #desktopUpload
            />
          </div>
          <img
            class="desktop-image-preview"
            *ngIf="form.value.desktopImage"
            [src]="form.value.desktopImage"
          />
        </span>

        <span class="p-float-label">
          <input
            type="url"
            pInputText
            formControlName="link"
            id="link"
            name="link"
          />
          <label for="link">Link *</label>
        </span>
        <span class="p-float-label">
          <input
            type="text"
            pInputText
            formControlName="altText"
            id="altText"
            name="altText"
          />
          <label for="altText">Alt Text *</label>
        </span>
        <span class="p-float-label">
          <input
            type="text"
            pInputText
            formControlName="countdown"
            id="countdown"
            name="countdown"
          />
          <label for="countdown">Countdown</label>
        </span>

        <span class="p-float-label">
          <p-calendar
            inputId="publishDate"
            dateFormat="dd/mm/yy"
            appendTo="body"
            formControlName="publishDate"
            [showTime]="true"
            [hourFormat]="24"
          />
          <label for="publishDate">Data de Publicação</label>
        </span>
        <span class="p-float-label">
          <p-calendar
            inputId="expirationDate"
            dateFormat="dd/mm/yy"
            appendTo="body"
            formControlName="expirationDate"
            [showTime]="true"
            [hourFormat]="24"
          />
          <label for="expirationDate">Data de Expiração</label>
        </span>

        <div class="w-full" style="grid-column: 1 / -1">
          <h4>Regras de Exibição</h4>
          <div
            class="displayRules"
            formGroupName="displayRules"
            style="
              display: grid;
              grid-template-columns: repeat(5, 1fr);
              gap: 10px;
            "
          >
            <div class="rule-group">
              <label>Assinante já comprou</label>
              <p-dropdown
                formControlName="subscriberBuyer"
                [options]="displayRuleOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                appendTo="body"
              ></p-dropdown>
            </div>
            <div class="rule-group">
              <label>Não assinante</label>
              <p-dropdown
                formControlName="notSubscriber"
                [options]="displayRuleOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                appendTo="body"
              ></p-dropdown>
            </div>
            <div class="rule-group">
              <label>Assinante nunca comprou</label>
              <p-dropdown
                formControlName="subscriberNotBuyer"
                [options]="displayRuleOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                appendTo="body"
              ></p-dropdown>
            </div>
            <div class="rule-group">
              <label>Assinante top badge</label>
              <p-dropdown
                formControlName="topBadgeSubscriber"
                [options]="displayRuleOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                appendTo="body"
              ></p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <span class="buttons">
    <p-button
      label="Voltar"
      severity="danger"
      routerLink="/configuracoes/glam/new-home"
    />
    <p-button label="Salvar" type="submit" [disabled]="!form.valid" />
  </span>
</form>
